{
  "activity": {
    "range_driving": "Range: driving",
    "range_long": "Range: woods and long irons",
    "range_irons": "Range: iron play",
    "wedge_play": "Wedge distance control",
    "short_game": "Pitching and chipping",
    "bunker": "Bunker practice",
    "putting_short": "Short putts",
    "putting_lag": "Lag putting",
    "trouble_shots": "Recovery shots",
    "weather_session": "Bad-weather session",
    "sim_swing": "Simulator: full swing",
    "sim_course": "Simulator: virtual course",
    "strategy_study": "Strategy and visualisation",
    "mental_session": "Mental coaching",
    "coach_lesson": "Lesson with your coach",
    "gym_strength": "Gym: strength",
    "gym_speed": "Gym: speed",
    "gym_mobility": "Gym: mobility",
    "gym_endurance": "Endurance",
    "rest": "Rest",
    "recovery_sauna": "Sauna",
    "recovery_ice": "Ice bath",
    "recovery_physio": "Physio",
    "practice_round": "Practice round",
    "travel_regional": "Travel",
    "travel_long": "Long-haul travel",
    "role_work": "Coach or club manager work",
    "family_fun": "Fun time"
  },
  "workload": {
    "green": "Green: steady",
    "amber": "Amber: ramping up fast",
    "red": "Red: high injury risk"
  },
  "week": {
    "title": "The week",
    "loading": "Getting your week",
    "error": "We could not get your week just now.",
    "retry": "Try again",
    "guest": "Make a golfer, and your coach will plan a week of practice.",
    "no_plan": "Your coach is still making this week's plan. It will be here after the 4 am change.",
    "approve": "Approve the week",
    "approved": "You approved this week's plan.",
    "approve_error": "We could not approve the plan just now. Try again.",
    "today": "Today",
    "state": {
      "done": "Done",
      "confirmed": "Confirmed",
      "can_change": "Can change"
    },
    "golf_hours": "{hours, plural, one {# golf hour} other {# golf hours}}",
    "extra_hours": "{hours, plural, one {plus # extra hour} other {plus # extra hours}}",
    "rest_day": "Rest",
    "school": "School until 4 pm",
    "block_hours": "{hours, plural, one {# hour} other {# hours}}",
    "trains": "Trains {skills}",
    "energy": {
      "label": "Energy at the start of the day",
      "short": "Energy",
      "fresh": "Fresh",
      "good": "Good",
      "tired": "Tired",
      "done": "Day done"
    },
    "forecast_note": "Energy here is a forecast. It changes if the plan changes.",
    "change_day": "Change this day",
    "change_short": "Change",
    "choose_day": "Choose a day",
    "whole_week": "See the whole week",
    "one_day": "See one day",
    "coach_default": "your coach",
    "day_a11y": "{weekday}, {state}. {hours}: {blocks}. Energy forecast: {energy}.",
    "day_a11y_no_energy": "{weekday}, {state}. {hours}: {blocks}.",
    "edit": {
      "title": "Change {weekday}",
      "intro": "Your changes win over the coach's plan.",
      "planned": "{used} of {budget} hours planned",
      "free": "{hours, plural, one {# hour left free} other {# hours left free}}",
      "hours": "{hours, plural, one {# hour} other {# hours}}",
      "line_label": "Hours of {activity}",
      "remove": "Take off {activity}",
      "add": "Add to the day",
      "add_one": "Add {activity}",
      "save": "Save the day",
      "saving": "Saving the day",
      "close": "Close",
      "keep": "Keep the day as it was",
      "saved": "Saved. Your plan for {weekday} is set.",
      "over": "That is more than the day holds. Take off some time first.",
      "refusal": {
        "over_budget": "That is more than the day's {allowed} hours.",
        "wrong_block_length": "{activity} needs whole blocks of time.",
        "lesson_without_coach": "A lesson needs a coach. Hire one first.",
        "lesson_without_focus": "A lesson needs something to work on.",
        "facility_not_available": "Your club does not have what {activity} needs.",
        "restricted_by_injury": "{activity} could make the injury worse. Pick something gentler.",
        "too_many_lessons": "Two lessons a day is the most.",
        "not_allowed_in_bought_hours": "{activity} cannot go in extra hours.",
        "other": "The day could not be saved as it is."
      },
      "warning": {
        "beyond_soft_cap": "Saved. More than {softCap} hours of practice in a day does less good for each hour.",
        "workload_forecast": "Saved. This is a heavy day after a busy week, so your golfer may tire."
      },
      "error": {
        "block_started": "Part of today has started, so today cannot change now. You can change a later day.",
        "day_not_open": "This day has gone, so it cannot change.",
        "other": "We could not save the day just now. Try again."
      }
    }
  },
  "team": {
    "title": "Your team",
    "open": "Your coach and team",
    "intro": "A coach makes every hour of practice count for more. You pay in Coins, one week at a time.",
    "cap_lines": "Bought support can make your golfer improve {capWords} sooner at most. The very best coaching can also raise a skill's limit, by {liftPoints, plural, one {# point} other {# points}} at most.",
    "loading": "Loading your team",
    "error": "We couldn't load your team. Try again.",
    "retry": "Try again",
    "guest": "A coach is for players with an account. Save your golfer to hire one.",
    "coach_heading": "Your coach",
    "none": "No coach yet. Pick a level below to see who is free.",
    "coach_line": "{name}, level {level}",
    "good_at": "Good at: {list}",
    "price": "{coins} Coins a week",
    "junior_price": "Golfers under 18 pay half price.",
    "find_heading": "Find a coach",
    "level_label": "Coach level",
    "level_value": "Level {level}",
    "level_hint": "A higher level helps more, and costs more.",
    "level_price": "{coins} Coins a week",
    "hire": "Hire",
    "hire_a11y": "Hire {name}",
    "yours": "Your coach",
    "confirm": "Hire {name} for {coins} Coins a week? The first week is paid now, then one week at a time each Monday.",
    "confirm_yes": "Hire {name}",
    "never_mind": "Never mind",
    "end": "Stop coaching",
    "end_confirm": "Stop working with {name} from now? This week was paid for, so nothing comes back.",
    "hired": "{name} is your coach from today.",
    "ended": "{name} is no longer your coach.",
    "refusal": {
      "not_enough_coins": "You haven't got enough Coins for the first week.",
      "already_your_coach": "{name} is your coach already.",
      "other": "That didn't work. Try again."
    },
    "speciality": {
      "long_game": "long game",
      "approach": "approach shots",
      "short_game": "short game",
      "putting": "putting",
      "mental": "the mental game",
      "strategy": "course strategy",
      "fitness": "fitness",
      "swing_rebuild": "swing rebuilds",
      "junior_dev": "young golfers",
      "adaptive": "adaptive golf"
    }
  },
  "extra": {
    "title": "Extra golf hours",
    "open": "Extra hours",
    "intro": "Add up to {max, plural, one {# golf hour} other {# golf hours}} to a day this week, for {coins} Coins an hour. Any time your golfer does not use comes back to you.",
    "loading": "Loading extra hours",
    "error": "We couldn't load your extra hours. Try again.",
    "retry": "Try again",
    "guest": "Extra hours are for players with an account. Save your golfer to add them.",
    "day_label": "Day",
    "today": "Today",
    "hours_label": "Extra hours",
    "hours_value": "{hours, plural, =0 {No extra hours} one {# extra hour} other {# extra hours}}",
    "placed": "Already added: {hours, plural, one {# hour} other {# hours}}.",
    "school_day": "This is a school day. Extra hours are only for days with no school.",
    "next_free_day": "The next day with no school this week is {day}.",
    "none_open": "There are no days left this week to add hours to.",
    "checks_heading": "Keeping up",
    "checks_intro": "Extra hours count for most when your golfer keeps up all four this week. Each one can be met for free.",
    "check": {
      "fitness": "Fitness: {hours, plural, one {# hour} other {# hours}} of gym in 7 days",
      "physio": "Physio: {hours, plural, one {# hour} other {# hours}} of physio in 7 days",
      "food": "Food: the Eat well habit",
      "sleep": "Sleep: the Sleep routine habit"
    },
    "met": "Met",
    "not_met": "Not met",
    "all_four": "All four: no extra strain",
    "some": "{met} of 4: these hours are worth {worth}% and carry a small injury risk",
    "price": "{hours, plural, one {# hour} other {# hours}}: {coins} Coins",
    "wallet": "You have {coins} Coins.",
    "add": "Add {hours, plural, one {# hour} other {# hours}} for {coins} Coins",
    "change": "Change to {hours, plural, one {# hour} other {# hours}} for {coins} Coins",
    "take_off": "Take the extra hours off",
    "took_off_note": "The Coins for them come back to you.",
    "done": "Done: {hours, plural, one {# extra hour} other {# extra hours}} on {day}.",
    "done_off": "The extra hours on {day} are off, and the Coins are back.",
    "refusal": {
      "not_enough_coins": "You haven't got enough Coins for these hours.",
      "school_day": "This is a school day. Extra hours are only for days with no school.",
      "day_not_open": "That day has started already. Pick a later day.",
      "bad_hours": "Pick up to {max, plural, one {# hour} other {# hours}}, in half hours.",
      "other": "That didn't work. Try again."
    }
  },
  "gfl": {
    "title": "Golf for life",
    "advice": "Each week, plan {hours, plural, one {# hour} other {# hours}} of gym, mobility or recovery on at least 3 days. Keep the Eat well and Sleep routine habits too. Then your golfer's power and fitness fade more slowly with age.",
    "advice_u18": "Each week, plan {hours, plural, one {# hour} other {# hours}} of gym, mobility or recovery on at least 3 days. Keep the Sleep routine habit too. Then your golfer's power and fitness fade more slowly with age.",
    "not_real_life": "This is not real-life advice. It only applies to your golfer in the game.",
    "checks_heading": "This week",
    "check": {
      "hours": "Gym, mobility or recovery: {done, plural, one {# hour} other {# hours}} planned, {need} needed",
      "days": "Days with a session: {days} of 3",
      "food": "Eat well habit",
      "sleep": "Sleep routine habit"
    },
    "met": "Met",
    "not_met": "Not met",
    "credit": "Age credit: {credit, plural, one {# year} other {# years}} (at most {max})",
    "credit_note": "Your golfer's power and fitness limits read as if they were this much younger. Your golfer still has to train up to them. Keep fewer than half a season's weeks and it drops by half a year."
  }
}
